import { get } from 'lodash'

// const loadingPageHost = get(process.env, 'LOADING_PAGE_HOST')

const types = {
  clinic: 'Clínica Médica',
  office: 'Consultório médico',
  'emergency_room': 'Emergência',
  laboratory: 'Labotarório',
  others: 'Outros'
}

/** tratando se for develop */
const getHost = () => {
  if (get(process.env, 'NODE_ENV') === 'development') {
    return window.location.host.replace(':8080', '')
  } else {
    return window.location.host
  }
}

const parseType = (type) => {
  return get(types, type, 'Outros')
}

const prepareShow = professionalProfilePublic => {
  professionalProfilePublic.company_type = parseType(professionalProfilePublic.agenda.address.company)

  return professionalProfilePublic
}

export default {
  async checkDomainOperator () {
    const host = {
      domain: getHost()
    }
    this.loading = true
    await this.$http.post('v1/scheduling/see/operator/domain', host)
      .then(({data}) => {
        /** Removendo valores anteriores */
        const operatorCovenantSession = localStorage.getItem('operador-covenant')
        if (operatorCovenantSession !== null) {
          localStorage.removeItem('operador-covenant')
        }

        /** setando dominio da operadora */
        localStorage.setItem('operador-domain', getHost())

        /** se tem resultado  */
        if (data.length >= 1) {
          /** retornando das do profissional */
          localStorage.setItem('operador-covenant', data[0].name)
        }
        // modificado para teste
        this.getByProfessional()
        this.getProfessionalSchedules()
      })
      .catch((error) => {
        this.loading = false
        this.afterFailure(error)
      })
  },
  /** retornando dados do profissional */
  async getByProfessional () {
    await this.$http.get('/v1/scheduling/see/professional/crm/' + this.crm + '/uf/' + this.uf)
      .then(({data}) => {
        this.profilePublic = data
        this.operatorCovenant = localStorage.getItem('operador-covenant')
        if (typeof this.profilePublic === 'object') {
          if (this.profilePublic.length <= 0) {
            this.noProfilePublic = true
          }
        }
        if (!this.noProfilePublic) {
          this.loading = true
        }
      })
      .catch((error) => {
        this.loading = false
        this.afterFailure(error)
      })
  },
  async getProfessionalSchedules () {
    await this.$http.get('/v1/scheduling/see/crm/' + this.crm + '/uf/' + this.uf + '/operator/' + getHost())
      .then(({data}) => {
        if (data.length > 0) {
          /** Retornando total de agendas */
          this.totalAgendas = data.length
          this.professionalProfilePublic = data

          /** somando quantidades de schdeludes para professional */
          this.totalAgendaSchedules = this.professionalProfilePublic.reduce((acc, item) => {
            return acc + item.total_agendas
          }, 0)

          /** Array para retorno do novo array  */
          let reduced = []

        /** Retornando quantidade de professionais pelo crm  */
          data.forEach((item) => {
            var duplicated = reduced.findIndex(ri => {
              return item.document === ri.document
            }) > -1

            if (!duplicated) {
              reduced.push(item)
            }
          })

          this.totalProfessional = reduced.length
          this.loading = false
        }
      })
      .catch((error) => {
        this.loading = false
        this.afterFailure(error)
      })
  },
  openExternalLink: function (url) {
    if (url === 'null') {
      return
    }
    window.open(url, '_blank')
  },
  prepareShow,
  typeClinic: function (type) {
    const clinicType = parseType(type)
    return clinicType
  },
  priceReal (price) {
    const real = price.split('.')
    return real[0]
  },
  priceCents (price) {
    const real = price.split('.')
    return real[1]
  }

}



// WEBPACK FOOTER //
// ./src/app/patient/profile-professional/gadget/resources/methods.js